export default "__VITE_ASSET__CQT_3NhZ__"